import cx from 'classnames';
import { PHONE, SIGNUP_AVATAR, SIGNUP_TITLE } from 'mk/autogenerated/translations/SignupProgressBar.cabfe5b85c54ec9772512e78c3e36d23'
import styles from 'mk2/apps/users/components/SignupProgressBar.mscss';
import React from 'react';

interface OwnProps {
    lastCircleActive: boolean;
}

const SignupProgressBar: React.StatelessComponent<OwnProps> = ({ lastCircleActive }) => (
    <svg className={styles.ProgressBar__svg}>
        <text className={styles.ProgressBar__checkedCircle} x="40" y="21">&#xf058;</text>
        <line x1="60" y1="12" x2="155" y2="12" className={styles.ProgressBar__firstLine} />
        <line x1="155" y1="12" x2="250" y2="12" className={cx(styles.ProgressBar__secondLine, lastCircleActive && styles['ProgressBar__secondLine--active'])} />
        <circle className={styles.ProgressBar__emptySecondCircle} />
        <circle className={styles.ProgressBar__fullSecondCircle} />
        <circle className={cx(styles.ProgressBar__emptyThirdCircle, lastCircleActive && styles['ProgressBar__emptyThirdCircle--active'])} />
        <circle className={cx(styles.ProgressBar__fullThirdCircle, lastCircleActive && styles['ProgressBar__emptyThirdCircle--active'])} />
        <text x="15" y="50" className={styles.ProgressBar__firstText}>{SIGNUP_TITLE}</text>
        <text x="130" y="50" className={cx(styles.ProgressBar__secondText, !lastCircleActive && styles['ProgressBar__secondText--active'])}>{PHONE}</text>
        <text x="220" y="50" className={cx(styles.ProgressBar__thirdText, lastCircleActive && styles['ProgressBar__thirdText--active'])}>{SIGNUP_AVATAR}</text>
    </svg>
);

export default SignupProgressBar;
